import BankTableActions from '@/components/bank/BankTableActions.vue';
import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import DataTableCurrency from '@/components/datatable/DataTableCurrency.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import type { Bank } from '@/types';
import { formatDateTime } from '@/utils/helpers';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<Bank>[] = [
    {
        accessorKey: 'id',
        enableColumnFilter: false,
    },
    {
        accessorKey: 'name',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'viia.table.account_name',
            }),
        sortingFn: 'text',
    },
    {
        accessorKey: 'number',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'viia.table.account_number',
            }),
    },
    {
        accessorKey: 'currency',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'viia.table.currency',
            }),
        filterFn: 'arrIncludesSome',
        meta: {
            filterType: 'checkbox',
        },
    },
    {
        accessorKey: 'booked',
        accessorFn: (row) => row.booked?.value,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'viia.table.balance',
            }),
        cell: ({ row }) =>
            h(DataTableCurrency, {
                value: row.original.booked?.value,
                addon: row.original.booked?.currency,
                withColor: false,
            }),
        meta: {
            filterType: 'currency',
        },
    },
    {
        accessorKey: 'owner',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'viia.table.owner',
            }),
    },
    {
        accessorKey: 'available',
        accessorFn: (row) => row.available?.value,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'viia.table.available',
            }),
        cell: ({ row }) =>
            h(DataTableCurrency, {
                value: row.original.available?.value,
                addon: row.original.available?.currency,
                withColor: false,
            }),
        meta: {
            filterType: 'currency',
        },
    },
    {
        accessorKey: 'lastSynchronized',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'viia.table.synced_at',
            }),
        cell: ({ row }) => formatDateTime(row.original.lastSynchronized as string),
        filterFn: 'dateRange',
        meta: {
            filterType: 'dateRange',
        },
    },
    {
        accessorKey: 'is_connected',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'viia.table.status',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: row.original.is_connected,
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'status',
        },
    },
    {
        accessorKey: 'connected_account',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'viia.economic_account',
            }),
    },
    {
        accessorKey: 'automatic_transfer',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'viia.table.automatic_transfer',
            }),
    },

    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'tables.actions',
            }),
        cell: ({ row }) => {
            return h(BankTableActions, {
                bank: row.original,
            });
        },
    },
];
